import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const pharmacyChainKeys = createQueryKeyStore({
  chains: {
    detail: (chainId: number) => [chainId],
    byIds: (serializedChainIds: string) => [serializedChainIds],
    all: (appName: string) => [appName],
    byAppName: (appName: string) => [appName],
  },
  counts: {
    list: null,
  },
});
